module.exports = __webpack_public_path__ + "img/survey.08cdbe97.png";